import { render, staticRenderFns } from "./GiveDiscountAdd.vue?vue&type=template&id=ff60e60a&scoped=true"
import script from "./GiveDiscountAdd.vue?vue&type=script&lang=js"
export * from "./GiveDiscountAdd.vue?vue&type=script&lang=js"
import style0 from "./GiveDiscountAdd.vue?vue&type=style&index=0&id=ff60e60a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff60e60a",
  null
  
)

export default component.exports